import * as React from 'react';

import { CONDITION_ALL, CONDITION_ANY, advancedDeliveryConditionHtmlOptions } from './utils';
import { Autocomplete, Box, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, Select, Stack, Switch, TextField, Typography } from '@mui/material';

import DeleteButton from '../components/DeleteButton';
import DeleteIconButton from '../components/DeleteIconButton';

const NotificationAdvancedRule = (props) => {
    const advanced_rule = props.data;
    const dm_map = Object.fromEntries(props.deliveryMethods.map(dm => [dm.id, dm]));
    const disabled = props.disabled;

    const onAdvancedRuleChange = (ev, dm) => {
        props.setNotification((prev) => {
            let delivery_method_advanced_rules = [...prev.delivery_method_advanced_rules];
            let selected_rule = [...delivery_method_advanced_rules.filter((ur) => ur.idx === advanced_rule.idx)][0];
            
            if(typeof dm === "object"){
                selected_rule[ev.target.name] = dm.map((rule) => rule.id);
            }
            else if(ev.target.name === "condition_any_all"){
                selected_rule[ev.target.name] = dm === false ? CONDITION_ANY : CONDITION_ALL;
            }
            else{
                selected_rule[ev.target.name] = ev.target.value;
            }

            delivery_method_advanced_rules = delivery_method_advanced_rules.filter((ur) => ur.idx !== advanced_rule.idx);

            return { ...prev, delivery_method_advanced_rules: [...delivery_method_advanced_rules, selected_rule] };
        });
    };

    return (
        <Grid container spacing={1} justifyContent={'space-between'} alignItems="flex-start" alignContent="center">
            <Grid item xs={12} sm={3}>
                <Autocomplete
                    disabled={disabled}
                    name="trigger_notification_delivery_methods"
                    options={props.deliveryMethods}
                    getOptionLabel={(option) => option?.option_str}
                    size="small"
                    multiple={true}
                    onChange={(event, value) => {
                        event.target.name = "trigger_notification_delivery_methods"
                        onAdvancedRuleChange(event, value);
                      }}
                    value={advanced_rule.trigger_notification_delivery_methods?.flatMap((dm) => dm_map[dm] ? dm_map[dm] : [])}
                    renderInput={(params) => <TextField {...params} variant="filled" color="primary"
                        label={advanced_rule.trigger_notification_delivery_methods?.length > 1 ?
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography style={{ marginTop: '-.55rem', marginLeft: '-.0rem' }}>If:&nbsp;&nbsp;&nbsp;<span style={{ fontWeight: advanced_rule.condition_any_all === CONDITION_ANY ? 600 : null }}>any</span></Typography>
                                <FormControlLabel onChange={onAdvancedRuleChange} name="condition_any_all" style={{ marginTop: '-.55rem', marginLeft: 0 }}
                                    control={<Switch checked={advanced_rule.condition_any_all === CONDITION_ALL} />} />
                                <Typography style={{ marginTop: '-.55rem', marginLeft: '-.0rem', fontWeight: advanced_rule.condition_any_all === CONDITION_ALL ? 600 : null }}>all</Typography>
                            </Stack>
                            : "If"} />}
                />
            </Grid>
            <Grid item xs={6} sm={2}>
                <FormControl fullWidth disabled={disabled}>
                    <InputLabel style={{ marginTop: '1rem' }} id="delivery_condition">
                        Is
                    </InputLabel>
                    <Select onChange={onAdvancedRuleChange} id="delivery_condition" name="condition" size="small" variant="filled" native value={advanced_rule.condition}>
                        {advancedDeliveryConditionHtmlOptions}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={1.25}>
                <FormControl fullWidth disabled={disabled}>
                    <TextField onChange={onAdvancedRuleChange} id="delivery_condition_delta_after" name="send_after_min" labelId="label_delivery_condition_delta_after" size="small" variant="filled"
                        label="After"
                        type="number"
                        InputProps={{
                            endAdornment: <InputAdornment position="end">min</InputAdornment>,
                            inputProps: { min: 0 }
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={advanced_rule.send_after_min}
                        />

                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
                <Autocomplete
                    disabled={disabled}
                    name="dependent_notification_delivery_methods"
                    options={props.deliveryMethods}
                    getOptionLabel={(option) => option?.option_str}
                    getOptionDisabled={(option) => advanced_rule.trigger_notification_delivery_methods?.includes(option.id)}
                    size="small"
                    multiple={true}
                    onChange={(event, value) => {
                        event.target.name = "dependent_notification_delivery_methods"
                        onAdvancedRuleChange(event, value);
                      }}
                    value={advanced_rule.dependent_notification_delivery_methods?.flatMap((dm) => dm_map[dm] ? dm_map[dm] : [])}
                    renderInput={(params) => <TextField {...params} variant="filled" color="primary" label="Then send" />}
                />
            </Grid>

            <Grid style={{ transform: 'translateX(-0.25rem)' }} component={Box} item xs={6} sm={1} container justifyContent="flex-end">
                {props.isSmallScreen ? (
                    <DeleteButton disabled={props.disableSaveButton || disabled} onClick={() => props.handleRemoveAdvancedRule(advanced_rule.idx)}>
                        Delete rule
                    </DeleteButton>
                ) : (
                    <DeleteIconButton title="Delete rule" size="medium" fontSize="medium" disabled={props.disableSaveButton || disabled} onClick={() => props.handleRemoveAdvancedRule(advanced_rule.idx)} />
                )}
            </Grid>
        </Grid>
    );
};

export default NotificationAdvancedRule;
